import { render } from "./ZoneRegisterDialog.vue?vue&type=template&id=22ca199b"
import script from "./ZoneRegisterDialog.vue?vue&type=script&lang=js"
export * from "./ZoneRegisterDialog.vue?vue&type=script&lang=js"

import exportComponent from "/w/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__